(function(angular, module) {var AmcGrantReportController,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

AmcGrantReportController = (function() {

  /* @ngInject */
  function AmcGrantReportController(ModelService, program, config, grantReport, data) {
    this.updateModel = bind(this.updateModel, this);
    this.ModelService = ModelService;
    this.program = program;
    this.config = config.config;
    this.sections = config.sections.sections;
    this.grantReport = grantReport;
    this.reportId = this.program.id + "/" + this.grantReport.grant_year;
    this.data = data;
    this.outcomeNames = [
      {
        name: "ed_award_rate_objective",
        unit: '%',
        max: 100,
        key: 'ed_award'
      }
    ];
    if (grantReport.grant_year <= 2015) {
      this.outcomeNames = this.outcomeNames.concat([
        {
          name: "full_ed_award_objective",
          unit: 'Member(s)',
          key: 'full_ed_award'
        }, {
          name: "credential_rate_objective",
          unit: '%',
          max: 100,
          key: "hse"
        }, {
          name: "job_placement_rate_objective",
          unit: '%',
          max: 100,
          key: 'job'
        }
      ]);
    } else {
      this.outcomeNames = this.outcomeNames.concat([
        {
          name: 'no_credential_objective',
          unit: 'Member(s)',
          key: 'no_credential'
        }, {
          name: 'credential_30d_objective',
          unit: '%',
          key: 'credential_30d'
        }, {
          name: 'credential_1y_objective',
          unit: '%',
          key: 'credential_1y'
        }, {
          name: 'job_placement_30d_objective',
          unit: '%',
          key: 'job_30d'
        }, {
          name: 'job_placement_1y_objective',
          unit: '%',
          key: 'job_1y'
        }
      ]);
    }
  }

  AmcGrantReportController.prototype.save = function(data) {
    return this.ModelService.patch('amc_grant_report', this.reportId, data);
  };

  AmcGrantReportController.prototype.lockReport = function() {
    var data;
    data = {
      locked: !this.grantReport.locked
    };
    return this.save(data);
  };

  AmcGrantReportController.prototype.updateModel = function(data) {
    angular.copy(data, this.grantReport);
    return this.grantReport;
  };

  AmcGrantReportController.prototype.saveSection = function(section, data) {
    var formData;
    formData = {};
    formData[section.name] = data;
    return this.save(formData);
  };

  return AmcGrantReportController;

})();

module.controller('AmcGrantReportController', AmcGrantReportController);
})(angular, angular.module("amcGrantReport"));